module.exports = __webpack_public_path__ + "img/pr-6.7696c9ad.png";